export var name = "@atlaskit/editor-core";
export var version = "0.0.0-development";